import React from 'react'
import { Form, Input } from 'antd';
import FormControls from '../../../../../components/form/FormControls/FormControls';

type CityFormInputsProps = {
    handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    resetChanges?: () => void
    submitForm: () => void
    clearForm?: () => void
}

export const CityFormInputs: React.FC<React.PropsWithChildren<CityFormInputsProps>> = (props) => {
    const {
        handleChange, resetChanges, submitForm,
        clearForm,
    } = props

    return (
        <>
            <Form.Item
                name="name"
                label="Название города"
                className="uif-ant-form-item"
            >
                <Input onInput={handleChange} />
            </Form.Item>

            <FormControls
                submitForm={submitForm}
                resetChanges={resetChanges}
                clearForm={clearForm}
            />
        </>
    )
}

export default CityFormInputs